import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import styles from './styles';
import { ProcessManagementQuestionsFormTextInputProps } from './types';

const ProcessManagementQuestionsFormTextInput = ({
  answerToDisplay,
  handleAnswerQuestion,
  placeholder,
}: ProcessManagementQuestionsFormTextInputProps) => {
  const [text, setText] = useState(answerToDisplay || '');
  const [charCount, setCharCount] = useState(answerToDisplay?.length || 0);
  const [hasChanges, setHasChanges] = useState(false);
  const maxChars = useMemo(() => 500, []);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newText = e.target.value;
      if (newText.length <= maxChars) {
        setText(newText);
        setCharCount(newText.length);
        setHasChanges(newText !== answerToDisplay);
      }
    },
    [maxChars, answerToDisplay]
  );

  const handleSave = useCallback(() => {
    handleAnswerQuestion(text);
    setHasChanges(false);
  }, [handleAnswerQuestion, text]);

  useEffect(() => {
    setText(answerToDisplay || '');
    setCharCount(answerToDisplay?.length || 0);
    setHasChanges(false);
  }, [answerToDisplay]);

  return (
    <>
      <TextField
        id="outlined-multiline-flexible"
        multiline
        variant="outlined"
        fullWidth
        onChange={handleChange}
        value={text}
        placeholder={placeholder}
        InputProps={{
          style: styles.textField,
        }}
      />
      <Box display="flex" justifyContent="space-between" mt={1}>
        <Box style={{ visibility: hasChanges ? 'visible' : 'hidden' }}>
          <Button variant="outlined" component="label" onClick={handleSave} style={styles.saveButton}>
            Save
          </Button>
        </Box>
        <Typography style={styles.charCount}>Characters left: {maxChars - charCount}</Typography>
      </Box>
    </>
  );
};

export default ProcessManagementQuestionsFormTextInput;
